<script>
import { mapActions, mapGetters } from 'vuex'
import SocialCreatePost from './SocialCreatePost'

export default {
  name: 'social-edit-post',
  extends: SocialCreatePost,
  props: {
    postId: Number
  },
  async created () {
    if (!this.profile) {
      await this.fetchProfile(this.profileNickname)
    }
    if (!this.post) {
      await this.fetchPost({ profileNickname: this.profileNickname, postId: this.postId })
    }
    if (!this.post) {
      this.$router.replace({ name: 'social', params: { profileNickname: this.profileNickname } })
      return
    }
    this.text = this.post.text
    this.imageSrc = this.post.image
    this.isEnabledLikes = this.post.isEnabledLikes
    this.isEnabledComments = this.post.isEnabledComments
  },
  computed: {
    ...mapGetters({
      profileById: 'entities/socialProfiles/getProfile',
      postById: 'entities/socialPosts/getPost'
    }),
    profile () {
      return this.profileById(this.profileNickname)
    },
    post () {
      return this.postById(this.postId)
    },
    title () {
      return this.$t('socialPost.editPostTitle')
    },
    buttonText () {
      return this.$t('buttonConfirm')
    }
  },
  methods: {
    ...mapActions({
      fetchProfile: 'entities/socialProfiles/fetchProfile',
      fetchPost: 'entities/socialPosts/fetchPost',
      updatePost: 'entities/socialPosts/updatePost'
    }),
    async onSubmit () {
      this.$v.$touch()
      if (this.loading || this.$v.$invalid) return
      const data = {
        text: this.text,
        isEnabledLikes: this.isEnabledLikes,
        isEnabledComments: this.isEnabledComments
      }
      if (this.imageSrc !== this.post.image && this.imageFile != null) {
        data.image = this.imageFile
      }
      this.loading = true
      try {
        await this.updatePost({
          profileNickname: this.profileNickname,
          postId: this.postId,
          data
        })
        this.$router.push({
          name: 'social',
          params: {
            profileNickname: this.profileNickname
          }
        })
      } catch (e) {
        this.$modal.show('error', {
          text: JSON.stringify(e.response.data)
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style module lang="scss">
// .container {
//   flex-grow: 1;
//   padding: 20px;
//   overflow-x: hidden;
//   overflow-y: scroll;
// }
.container {
  padding: 16px 25px;
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: scroll;
  .button {
    margin: 14px auto;
  }
}
.title {
  font-size: 18px;
  font-weight: 500;
  color: $text-success;
  margin: 0;
  margin-bottom: 16px;
  text-align: center;
}
.file {
  margin-bottom: 14px;
}
.fileIcon {
  font-size: 18px;
  color: $text-colored;
}
.imageWrap {
  text-align: center;
}
.image {
  margin: 0 auto;
  max-width: 100%;
  max-height: 450px;
  object-fit: contain;
}
.switchMargin {
  margin-bottom: 2px;
}
</style>
